export const heroLogo = (
  <svg viewBox="0 0 436 109">
    <defs>
      <filter
        id="prefix__a"
        x={101.125}
        y={1.25}
        width={333.906}
        height={106.562}
        filterUnits="userSpaceOnUse"
      >
        <feFlood result="flood" floodColor="#5e5e5e" />
        <feComposite result="composite" operator="in" in2="SourceGraphic" />
        <feBlend result="blend" in2="SourceGraphic" />
      </filter>
      <clipPath id="v-clip">
        <path d="M37.754 105.5H58.2L95.786 2.394H74.762L52.586 64.458l-4.032 13.248H47.4l-3.742-13.248L22.346 2.394H1.322z" />
      </clipPath>
      <linearGradient id="shimmer-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0" />
        <stop offset="35%" stopColor="#ffffff" stopOpacity="0" />
        <stop offset="50%" stopColor="#ffffff" stopOpacity="0.4" />
        <stop offset="65%" stopColor="#ffffff" stopOpacity="0" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
      </linearGradient>
    </defs>
    {/* V with shimmer effect */}
    <g clipPath="url(#v-clip)">
      <path
        d="M37.754 105.5H58.2L95.786 2.394H74.762L52.586 64.458l-4.032 13.248H47.4l-3.742-13.248L22.346 2.394H1.322z"
        fill="#00a2ff"
        fillRule="evenodd"
      />
      <rect
        className="hero-shimmer"
        x="-200"
        y="-10"
        width="250"
        height="130"
        fill="url(#shimmer-gradient)"
      />
    </g>
    <path
      d="M121.851 21.906a11.552 11.552 0 003.6-8.568 11.559 11.559 0 00-3.6-8.568 12.232 12.232 0 00-17.208 0 12.192 12.192 0 00-2.592 3.816 11.791 11.791 0 00-.936 4.752 11.791 11.791 0 00.936 4.752 12.167 12.167 0 002.592 3.816 12.255 12.255 0 0017.208 0zm.864 83.592v-70.56h-18.864V105.5h18.864zm34.99-69.408h-17.712v70.56h18.864V72.09q0-9.359 5.112-14.76t14.04-5.4a21.9 21.9 0 014.68.432 17.982 17.982 0 013.528 1.152v-18.72a12.651 12.651 0 00-2.736-.576q-1.441-.142-3.888-.144a23.941 23.941 0 00-12.312 3.24 21.874 21.874 0 00-8.424 8.568h-1.152V36.09zM207.1 82.667q0 12.2 6.768 18.815a20.351 20.351 0 007.128 4.63 25.743 25.743 0 009.576 1.69 41.686 41.686 0 008.424-.792 31.262 31.262 0 007.128-2.376l-5.328-16.56a10.476 10.476 0 01-6.624 1.872 7.131 7.131 0 01-5.76-2.374 7.576 7.576 0 01-1.944-3.636 20.362 20.362 0 01-.5-4.675V51.066h17.28V34.938h-17.28v-21.6H207.1v21.6h-12.387v16.128H207.1v31.6zm69.837-60.761a11.552 11.552 0 003.6-8.568 11.559 11.559 0 00-3.6-8.568 12.232 12.232 0 00-17.208 0 12.192 12.192 0 00-2.592 3.816 11.791 11.791 0 00-.936 4.752 11.791 11.791 0 00.936 4.752 12.167 12.167 0 002.592 3.816 12.255 12.255 0 0017.205 0zm.863 83.594V34.938h-18.866V105.5H277.8zm66.094 0H361.6V34.938h-18.86V69.5a29.744 29.744 0 01-1.08 8.136 20.234 20.234 0 01-3.168 6.624 15.984 15.984 0 01-5.04 4.464 13.74 13.74 0 01-6.84 1.656q-6.48 0-9.864-3.672t-3.384-11.3v-40.47H294.5v42.768q0 13.682 6.552 21.888T321 107.8a26.117 26.117 0 0012.816-3.1 23.91 23.91 0 008.928-8.424h1.152v9.224zm73.368.432a30.016 30.016 0 009.5-5.112 23.532 23.532 0 006.12-7.416 18.859 18.859 0 002.16-8.784 19.183 19.183 0 00-5.256-13.464q-5.259-5.687-16.056-8.28l-10.8-2.592a29.164 29.164 0 01-6.84-2.592 4.348 4.348 0 01-2.52-3.888q0-2.592 3.024-4.248a14.475 14.475 0 017.056-1.656 17.81 17.81 0 017.776 1.872 12.49 12.49 0 015.9 6.048l16.274-6.626a24.4 24.4 0 00-11.664-12.6 39.725 39.725 0 00-18-3.96 40.722 40.722 0 00-11.3 1.512 29.284 29.284 0 00-9.144 4.32 20.8 20.8 0 00-6.12 6.84 18.69 18.69 0 00-2.232 9.216 16.659 16.659 0 001.872 8.064 20.364 20.364 0 004.752 5.9 26.633 26.633 0 006.408 4.032 34.583 34.583 0 006.84 2.3l9.936 2.16q6.189 1.441 8.712 3.24a5.519 5.519 0 012.52 4.68q0 2.592-3.024 4.464a15.5 15.5 0 01-8.208 1.872 16.421 16.421 0 01-9.144-2.664 18.194 18.194 0 01-6.552-8.136l-16.848 7.2a31.077 31.077 0 004.176 7.416 29.586 29.586 0 006.7 6.48 33.944 33.944 0 009.36 4.536 40.363 40.363 0 0012.312 1.728 38.377 38.377 0 0012.308-1.864z"
      filter="url(#prefix__a)"
      fill="#00a2ff"
      fillRule="evenodd"
    />
  </svg>
);

export const virtiusV = (
  <svg width={192} height={192} viewBox="0 0 512 512">
    <path
      d="M217.668 439.078h72.7L424 72.486h-74.748L270.4 293.158l-14.336 47.1h-4.1l-13.312-47.1-75.768-220.672H88.132z"
      fill="#00a2ff"
      fillRule="evenodd"
    />
  </svg>
);
